document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[id^="ProductMediaGallery-"]').forEach(function (gallery) {

    const mainEl  = gallery.querySelector('.product-main-swiper');
    const thumbEl = gallery.querySelector('.product-thumb-swiper');
    if (!mainEl || !thumbEl) return;

    let isHovering = false;

    /* ----------------------------
       THUMB SWIPER
    ---------------------------- */
    const thumbSwiper = new Swiper(thumbEl, {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      breakpoints: { 768: { slidesPerView: 6 } },
    });

    const nextBtn = gallery.querySelector('.slider-button--next');
    const prevBtn = gallery.querySelector('.slider-button--prev');
    const paginationEl = gallery.querySelector('.main-pagination');

    /* ----------------------------
       MAIN SWIPER (🚫 NO AUTOPLAY)
    ---------------------------- */
    const mainSwiper = new Swiper(mainEl, {
      loop: true,
      speed: 600,
      spaceBetween: 0,

      // ❌ autoplay removed completely

      pagination: paginationEl ? { el: paginationEl, clickable: true } : {},
      navigation: {
        nextEl: nextBtn || null,
        prevEl: prevBtn || null,
      },
      thumbs: { swiper: thumbSwiper },
      observer: true,
      observeParents: true,

      on: {
        init() {
          // Preload videos
          this.slides.forEach(slide => {
            const video = slide.querySelector('video');
            if (video) {
              video.preload = "auto";
              video.muted = true;
              video.playsInline = true;
              video.load();
            }
          });

          handleSlideMedia(this);
        },

        slideChangeTransitionEnd() {
          handleSlideMedia(this);
        }
      }
    });

    /* --------------------------------------------------
       MEDIA HANDLING (ONLY PLAY ACTIVE VIDEO)
    -------------------------------------------------- */
    function handleSlideMedia(swiper) {

      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const activeVideo = activeSlide.querySelector('video');

      // ▶ Play active video instantly
      if (activeVideo) {
        activeVideo.muted = true;
        activeVideo.playsInline = true;

        if (activeVideo.readyState >= 2) {
          activeVideo.currentTime = 0;
          activeVideo.play().catch(() => {});
        } else {
          activeVideo.addEventListener('loadeddata', () => {
            activeVideo.currentTime = 0;
            activeVideo.play().catch(() => {});
          }, { once: true });
        }
      }

      // ⏸ Pause all other videos
      swiper.slides.forEach(slide => {
        if (slide !== activeSlide) {
          slide.querySelectorAll('video').forEach(video => {
            video.pause();
            video.currentTime = 0;
          });
        }
      });

      // ▶ Iframe autoplay (only active)
      const wrapper = activeSlide.querySelector('[data-iframe-src]');
      if (wrapper) {
        const iframe = wrapper.querySelector('iframe');
        if (iframe) {
          const base = wrapper.dataset.iframeSrc || iframe.src;
          iframe.src = base.includes('?')
            ? base + '&autoplay=1&mute=1'
            : base + '?autoplay=1&mute=1';
        }
      }

      // ⏹ Stop other iframes
      swiper.slides.forEach(slide => {
        if (slide !== activeSlide) {
          slide.querySelectorAll('iframe').forEach(frame => {
            if (!frame.src) return;
            frame.src = frame.src.replace(/([&?])autoplay=1(&?)/, '');
          });
        }
      });
    }

  });
});